import React, { useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useTranslation } from "react-i18next";
import { Toast } from "primereact/toast";
import { FilterMatchMode } from "primereact/api";
import { Dropdown } from "primereact/dropdown";

function RunningMetadataDialog({
  measuresMetadata,
  setMeasuresData,
  visible,
  onHide,
}) {
  const { t } = useTranslation();
  const toast = useRef(null);
  const [filters, setFilters] = useState({
    RunningName: { value: null, matchMode: FilterMatchMode.EQUALS },
    Machine: { value: null, matchMode: FilterMatchMode.EQUALS },
    Name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    EnDescr: { value: null, matchMode: FilterMatchMode.CONTAINS },
  });

  // Extract unique RunningNames for dropdown options
  const runningNameOptions = [
    ...new Set(measuresMetadata.map((item) => item.RunningName)),
  ].map((name) => ({ label: name, value: name }));

  const machineOptions = [
    ...new Set(measuresMetadata.map((item) => item.Machine)),
  ].map((machine) => ({ label: machine, value: machine }));

  // Custom filter template
  const runningNameFilterTemplate = (options) => {
    return (
      <Dropdown
        value={options.value}
        options={runningNameOptions}
         onChange={(e) => {
          options.filterCallback(e.value, options.index);
          const newFilters = { ...filters };
          newFilters.RunningName.value = e.value;
          setFilters(newFilters);
        }}
        className="p-column-filter"
        showClear
        filter
        searchable
      />
    );
  };
  const machineFilterTemplate = (options) => {
    return (
      <Dropdown
        value={options.value}
        options={machineOptions}
         onChange={(e) => {
          options.filterCallback(e.value, options.index);
          const newFilters = { ...filters };
          newFilters.Machine.value = e.value;
          setFilters(newFilters);
        }}
        className="p-column-filter"
        showClear
        filter
      />
    );
  };

  return (
    <Dialog
      header={
        <div
          style={{ display: "flex", alignItems: "center"}}
        >
          <i className="pi pi-cog" style={{ marginRight: "0.5rem" }}></i>
          {t("measuresDetails")}
        </div>
      }
      visible={visible}
      onHide={onHide}
      style={{ width: "90%" }}
    >
      <Toast ref={toast} />
      <DataTable
        value={measuresMetadata}
        stripedRows
        paginator
        rows={10}
        rowsPerPageOptions={[10, 20, 50]}
     
        filters={filters}
        onFilter={(e) => {
          setFilters(e.filters);
        }}
      >
        <Column
          field="Machine"
          header={t("machine")}
          sortable
          filter
          filterElement={machineFilterTemplate}
          showFilterMenu={false}
          filterMatchMode="equals" // ✅ Fix: explicitly define match mode
        />
        <Column field="Name" header={t("name")} sortable filter />
        <Column
          field="RunningName"
          header={t("runningname")}
          sortable
          filter
          filterElement={runningNameFilterTemplate}
          showFilterMenu={false}
          filterMatchMode="equals" // ✅ Fix: explicitly define match mode

        />
        <Column field="EnDescr" header={t("description")} sortable filter />
      </DataTable>
    </Dialog>
  );
}
export default RunningMetadataDialog;
